import { render, staticRenderFns } from "./ECommerceWishList.vue?vue&type=template&id=40144314&scoped=true&"
import script from "./ECommerceWishList.vue?vue&type=script&lang=js&"
export * from "./ECommerceWishList.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceWishList.vue?vue&type=style&index=0&id=40144314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40144314",
  null
  
)

export default component.exports